import { Config } from "config/config.type"
/** @firescoutMockVar Config.config */
const config:Config = {
  "env": "prod",
  "location": "lusini_de-de",
  "shopName": "lusini",
  "locale": "de-de",
  "rootCategoryId": "EMG",
  "orderMinimumB2C": 20,
  "availableCreditCards": [
    "MASTERCARD",
    "VISA"
  ],
  "links": {
    "contact": "/helpandservice/kontakt/"
  },
  "i18n": {
    "currency_ISO": "EUR",
    "locale": "de-DE",
    "country": "DE"
  },
  "languages": {
    "de": "Deutsch",
    "en": "Englisch",
    "fr": "Französisch",
    "es": "Spanisch",
    "it": "Italienisch",
    "nl": "Niederländisch",
    "pt": "Portugiesisch",
    "sv": "Schwedisch",
    "da": "Dänisch",
    "nb": "Norwegisch",
    "hr": "Kroatisch"
  },
  "slugifyLocale": "de",
  "hrefLang": [
    {
      "configFolder": "lusini",
      "locale": "de-de",
      "hrefLang": "de"
    },
    {
      "configFolder": "lusini",
      "locale": "de-at",
      "hrefLang": "de-at"
    },
    {
      "configFolder": "lusini",
      "locale": "de-ch",
      "hrefLang": "de-ch"
    }
  ],
  "baseUrl": "https://www.lusini.com",
  "functions": {
    "clientdata": "https://functions.lusini.com/.netlify/functions/clientdata",
    "newsletter": {
      "getOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-getOptInStatus",
      "createContactWithOptIn": "https://functions.lusini.com/.netlify/functions/newsletter-createContactWithOptIn",
      "setOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-setOptInStatus"
    },
    "creditsave": {
      "address": "https://functions.lusini.com/.netlify/functions/creditsafe-address"
    },
    "shareCart": {
      "POST": "https://functions.lusini.com/.netlify/functions/shareCart-POST",
      "GET": "https://functions.lusini.com/.netlify/functions/shareCart-GET"
    },
    "raffle": {
      "registration": "https://functions.lusini.com/.netlify/functions/POST-raffle-registration"
    }
  },
  "modules": {
    "onetrust": {
      "dataDomainScript": "bda0c016-94be-4fd9-943a-b9c09791a327"
    },
    "paypalExpress": {
      "clientId": "AUo3HQdo8k6N4yikenWOhQdVQA3c9joe_39HVQzDsG9XV3esMeAWBYu9oY-vfPe_ija_Zijo0Ppz56XS"
    },
    "cloudinary": {
      "endpoint": "https://res.cloudinary.com/lusini/",
      "transformations": {
        "freisteller_l": "w_1500,h_1500,q_80,c_pad,f_auto",
        "freisteller_l_2": "w_1500,h_1500,q_80,c_pad,f_auto",
        "milieu_l": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "milieu_l_2": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "freisteller_m": "w_500,h_500,q_70,c_pad,f_auto",
        "freisteller_m_2": "w_500,h_500,q_70,c_pad,f_auto",
        "milieu_m": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "milieu_m_2": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "freisteller_s": "w_300,h_300,q_70,c_pad,f_auto",
        "freisteller_s_2": "w_600,h_600,q_70,c_pad,f_auto",
        "milieu_s": "w_300,h_300,g_auto,q_70,c_fill,f_auto",
        "milieu_s_2": "w_600,h_600,g_auto,q_70,c_fill,f_auto",
        "freisteller_xs": "w_50,h_50,q_50,c_pad,fl_lossy,f_auto",
        "freisteller_xs_2": "w_100,h_100,q_50,c_pad,fl_lossy,f_auto",
        "milieu_xs": "w_50,h_50,g_auto,q_50,c_fill,fl_lossy,f_auto",
        "milieu_xs_2": "w_100,h_100,g_auto,q_50,c_fill,fl_lossy,f_auto"
      },
      "fallback_product_picture": "https://res.cloudinary.com/lusini/image/upload/v1643182695/application/products/lusini-online-shop-platzhalter-produktbild-in-kuerze-de.svg",
      "newsletter_intentlayer_picture": "https://res.cloudinary.com/lusini/image/upload/v1724665736/application/NewsletterPopupAB/discount-reduction-de-de.svg"
    },
    "shopware": {
      "apiUrl": "https://shop-api.lusini.com/store-api",
      "salutations": [
        "mr",
        "ms",
        "not_specified"
      ],
      "initialSaluationId": "6d0b33d96b5b400cbabc648c0a4c3f60",
      "accessKey": {
        "b2b": "SWSCZWLYZUXM53HITXGTLPW13S",
        "b2c": "SWSCDUFWH1P565M7GCUNFWDS3J"
      },
      "storefrontUrl": {
        "b2b": "https://www.lusini.com/de-de/b2b",
        "b2c": "https://www.lusini.com/de-de/b2c"
      }
    },
    "algolia": {
      "apiKey": "bf4bf9193d5f34cd369647376521dbc8",
      "applicationId": "WAVYBEW6OQ"
    },
    "contentful": {
      "space": "aza65graowyr",
      "environment": "master",
      "accessToken": "CiHQe6Rhx0nDcBT3Siv4qHIUk2xC6CcSwTbtIdMStyk",
      "previewToken": "J9M50p9PZokU9L3-SiDXcfDvVHpcTCzWyLSznbtHPWA"
    },
    "dyHybrid": {
      "apiKey": "36ac5fd76da488da1815369c11a826ac2cca1d12df164068917706c430418a29",
      "campaignID": "9879542"
    },
    "trustShop": {
      "placeholderImg": "https://res.cloudinary.com/lusini/image/upload/c_scale,w_100/v1670412947/application/icons/trusted-shops-guarantee.svg",
      "id": "X8F8D030F9EB05EAF5450296CAF296031",
      "url": "https://widgets.trustedshops.com/js/",
      "urlPostfix": ".js"
    },
    "zenloop": {
      "id": "WlRFeE9UQTVORFl0TWpsak9DMDBaRFZpTFdFNE9XRXRNemczTVRFeE5qWTNZalpq"
    },
    "hotjar": {
      "id": 3549008,
      "version": 6,
      "cartActive": true,
      "checkoutActive": true
    },
    "taboola": {
      "id": "1491752"
    },
    "linkedIn": {
      "id": 6229249
    }
  },
  "index": {
    "products": "prod_lusini_de_DE_products",
    "productsPriceAsc": "prod_lusini_de_DE_products_priceAsc",
    "productsPriceDesc": "prod_lusini_de_DE_products_priceDesc",
    "categories": "prod_lusini_de_DE_categories",
    "series": "prod_lusini_de_DE_series",
    "productsSuggestion": "prod_lusini_de_DE_products_query_suggestions",
    "productsLatest": "prod_lusini_de_DE_products_noveltiesAsc",
    "productReviews": "prod_lusini_product_reviews",
    "serviceReviews": "prod_lusini_service_reviews"
  },
  "deliveryDate": {
    "shippingTooLong": 200
  },
  "colors": {
    "Weiß": "white",
    "Schwarz": "black",
    "Grau": "grey",
    "Silber": "silver",
    "Braun": "brown",
    "Blau": "blue",
    "Mehrfarbig": "multicolor",
    "Rot": "red",
    "Beige": "beige",
    "Grün": "green",
    "Transparent": "transparent",
    "Gelb": "yellow",
    "Gold": "gold",
    "Orange": "orange",
    "Rosa/Lila": "lilac"
  },
  "features": {
    "showProductRecommendationInfoTextB2B": true,
    "showProductRecommendationInfoTextB2C": true,
    "taboola": true,
    "devMode": false,
    "trustShop": true,
    "zenloop": true,
    "qrCode": true,
    "b2c": true,
    "userLikeWidgetUrl": "",
    "disposalOfLegacyDevice": "/helpandservice/bestellung/batterie-und-elektrogeraete-entsorgung/",
    "customizableUrl": "https://www.lusini.com/de-de/helpandservice/serviceleistungen/personalisierung/",
    "b2cHomePage": true,
    "hotjar": true,
    "marketPlace": true,
    "linkedIn": true,
    "notificationBar": true,
    "showNewsletterIntentLayer": true,
    "emarsysWebExtend": true,
    "emarsysWebExtendMerchantId": "17994273E17ED6DD",
    "cmpConsilius3dViewer": {
      "language": "de"
    }
  },
  "abTests": {},
  "showTelephoneContactOnFailedCheckoutThreshold": 0
}
export default config